import { inject, Injectable, signal } from '@angular/core';
import { ReadonlyRepositoryListService } from '@softline/core';
import { TaskTypesRepository } from '../repositories/task-types.repository';
import { TaskType } from '../types/task-type';

@Injectable()
export class TaskTypesService extends ReadonlyRepositoryListService<
  TaskType,
  TaskType[],
  undefined
> {
  protected override repository = inject(TaskTypesRepository);

  constructor() {
    super(inject(TaskTypesRepository));
  }

  params = signal(undefined);

  getItems(result: TaskType[] | null | undefined): TaskType[] {
    //sort alphabetically by description
    return (
      result?.sort((a, b) => a.shortDescription.localeCompare(b.shortDescription)) ?? []
    );
  }
}
